/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoceForm { 
    origine?: string;
    tipo?: string;
    messaggio?: string;
    stack?: string;
    form?: string;
    campo?: string;
    regola?: string;
    pagina?: string;
    comune_slug?: string;
    occurred_at?: string;
    ripetizioni?: number;
}

